import request from "@/api/request";

export default {
    // 获取配置
    getConfig: async data => request({url: '/console/market.FreeShip/getConfig', data}),
    // 保存
    saveConfig: async data => request({url: '/console/market.FreeShip/saveConfig', data}),

}
